var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ADDRESS_TYPES, COUNTRIES, PHONE_TYPES, YES_NO_FLAGS, } from '../models/common/addresses';
import { removeNonDigitsFromString } from './general';
export var mapAddressListToCommonModel = function (addresses, paginationInfo) {
    var mappedAddresses = addresses.map(function (address) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return {
            isDefault: address.isDefault || false,
            companyName: 'companyName' in address ? address.companyName : undefined,
            firstName: ((_a = address.name) === null || _a === void 0 ? void 0 : _a.firstName) || '',
            lastName: ((_b = address.name) === null || _b === void 0 ? void 0 : _b.lastName) || '',
            nickName: address.name && 'nickName' in address.name
                ? address.name.nickName
                : undefined,
            addedBy: 'addedBy' in address ? address.addedBy : undefined,
            primaryPhone: 'phones' in address
                ? ((_d = (_c = address.phones) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.number) || ''
                : ('primaryPhone' in address && ((_e = address.primaryPhone) === null || _e === void 0 ? void 0 : _e.number)) || '',
            alternatePhone: 'phones' in address
                ? (_g = (_f = address.phones) === null || _f === void 0 ? void 0 : _f[1]) === null || _g === void 0 ? void 0 : _g.number
                : ('alternatePhone' in address && ((_h = address.alternatePhone) === null || _h === void 0 ? void 0 : _h.number)) ||
                    '',
            addressLine1: ((_j = address.postalDetails) === null || _j === void 0 ? void 0 : _j.addressLine1) || '',
            addressLine2: (_k = address.postalDetails) === null || _k === void 0 ? void 0 : _k.addressLine2,
            state: ((_l = address.postalDetails) === null || _l === void 0 ? void 0 : _l.state) || '',
            zipCode: ((_m = address.postalDetails) === null || _m === void 0 ? void 0 : _m.zipCode) || '',
            city: ((_o = address.postalDetails) === null || _o === void 0 ? void 0 : _o.city) || '',
            userId: 'userId' in address ? address.userId : undefined,
            lastModifiedDate: address.lastModifiedDate,
            addrIdentifier: address.addrIdentifier,
        };
    });
    return {
        addresses: mappedAddresses,
        paginationInfo: __assign(__assign({}, (paginationInfo || {})), { addressesOnCurrentPage: addresses.length }),
        response: addresses,
    };
};
export var mapProfileDataToB2CAddAdressRequestModel = function (profileData, paymentFormValues, isNoAddresses) {
    var _a, _b, _c, _d;
    var firstName = (_a = profileData.account.profile.name) === null || _a === void 0 ? void 0 : _a.firstName;
    var lastName = (_b = profileData.account.profile.name) === null || _b === void 0 ? void 0 : _b.lastName;
    var primaryPhone = (_d = (_c = profileData.account.profilePhones) === null || _c === void 0 ? void 0 : _c.phone) === null || _d === void 0 ? void 0 : _d[0].number;
    if (!firstName || !lastName || !primaryPhone)
        throw Error('No required fields');
    var addressValues = {
        firstName: firstName,
        lastName: lastName,
        primaryPhone: primaryPhone,
        zipCode: paymentFormValues.zipCode,
        isDefault: false,
        addressLine1: paymentFormValues.addressLine1,
        addressLine2: paymentFormValues.addressLine2,
        cityState: paymentFormValues.cityState,
        companyName: '',
        alternatePhone: '',
        nickName: '',
    };
    return mapAddAddressToRequestModel(false, addressValues, isNoAddresses);
};
export var mapAddAddressToRequestModel = function (isB2B, addressValues, isNoAddresses) {
    var _a = addressValues.companyName, companyName = _a === void 0 ? '' : _a, isDefault = addressValues.isDefault, nickName = addressValues.nickName, lastName = addressValues.lastName, firstName = addressValues.firstName, addressLine1 = addressValues.addressLine1, zipCode = addressValues.zipCode;
    var cityState = addressValues.cityState.split(',');
    var city = cityState[0].trim();
    var state = cityState[1].trim();
    var addressLine2 = addressValues.addressLine2 || undefined;
    var primaryPhone = removeNonDigitsFromString(addressValues.primaryPhone);
    var alternatePhone = addressValues.alternatePhone
        ? removeNonDigitsFromString(addressValues.alternatePhone)
        : undefined;
    if (isB2B) {
        var phones = [
            {
                number: primaryPhone,
                primaryFlag: YES_NO_FLAGS.YES,
                type: PHONE_TYPES.UNKNOWN,
            },
        ];
        if (alternatePhone) {
            phones.push({
                number: alternatePhone,
                type: PHONE_TYPES.UNKNOWN,
                primaryFlag: YES_NO_FLAGS.NO,
            });
        }
        return {
            addressType: ADDRESS_TYPES.SHIPPING,
            companyName: companyName,
            isDefault: isDefault,
            name: {
                firstName: firstName,
                lastName: lastName,
                nickName: nickName,
            },
            phones: phones,
            postalDetails: {
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                city: city,
                country: COUNTRIES.US,
                state: state,
                zipCode: zipCode,
            },
        };
    }
    return {
        isDefault: !!isNoAddresses,
        name: {
            firstName: firstName,
            lastName: lastName,
        },
        postalDetails: {
            city: city,
            addressLine1: addressLine1,
            addressLine2: addressLine2,
            state: state,
            country: COUNTRIES.US,
            zipCode: zipCode,
        },
        primaryPhone: {
            number: primaryPhone,
        },
        alternatePhone: alternatePhone
            ? {
                number: alternatePhone,
            }
            : undefined,
    };
};
export var mapEditAddressToRequestModel = function (isB2B, addressValues, fullAddressData) {
    var _a, _b, _c, _d, _e;
    var alternatePhone = addressValues.alternatePhone
        ? removeNonDigitsFromString(addressValues.alternatePhone)
        : undefined;
    if (isB2B) {
        var b2bRequestData = mapAddAddressToRequestModel(isB2B, addressValues, false);
        var phones = b2bRequestData.phones.map(function (phone, ind) {
            var _a, _b;
            return (__assign(__assign({}, phone), { id: (_b = (_a = fullAddressData.phones) === null || _a === void 0 ? void 0 : _a[ind]) === null || _b === void 0 ? void 0 : _b.id }));
        });
        if (!alternatePhone && ((_a = fullAddressData.phones) === null || _a === void 0 ? void 0 : _a[1])) {
            phones.push({
                id: (_c = (_b = fullAddressData.phones) === null || _b === void 0 ? void 0 : _b[1]) === null || _c === void 0 ? void 0 : _c.id,
            });
        }
        b2bRequestData.phones = __spreadArray([], phones, true);
        b2bRequestData.level = fullAddressData.level;
        b2bRequestData.lastModifiedDate = fullAddressData.lastModifiedDate;
        b2bRequestData.addrIdentifier = fullAddressData.addrIdentifier;
        if (fullAddressData.userId) {
            b2bRequestData.userId = fullAddressData.userId;
        }
        return b2bRequestData;
    }
    var b2cRequestData = mapAddAddressToRequestModel(isB2B, addressValues, false);
    b2cRequestData.isDefault = addressValues.isDefault;
    b2cRequestData.primaryPhone.contactMethodEnumeration =
        (_d = fullAddressData.primaryPhone) === null || _d === void 0 ? void 0 : _d.contactMethodEnumeration;
    b2cRequestData.primaryPhone.id = (_e = fullAddressData.primaryPhone) === null || _e === void 0 ? void 0 : _e.id;
    if (fullAddressData.alternatePhone) {
        b2cRequestData.alternatePhone = {
            number: alternatePhone || '',
            id: fullAddressData.alternatePhone.id,
        };
    }
    b2cRequestData.fraudChecked = fullAddressData.fraudChecked;
    b2cRequestData.instantCheckoutDefault =
        fullAddressData.instantCheckoutDefault;
    b2cRequestData.addrIdentifier = fullAddressData.addrIdentifier;
    b2cRequestData.lastModifiedDate = fullAddressData.lastModifiedDate;
    return b2cRequestData;
};
export var mapAddressFormToMappedModal = function (address) {
    var _a = address.cityState.split(', '), city = _a[0], state = _a[1];
    return {
        isDefault: address.isDefault || false,
        companyName: address.companyName || '',
        primaryPhone: address.primaryPhone || '',
        alternatePhone: address.alternatePhone || '',
        firstName: address.firstName || '',
        lastName: address.lastName || '',
        nickName: address.nickName || '',
        zipCode: address.zipCode || '',
        addressLine1: address.addressLine1 || '',
        addressLine2: address.addressLine2 || '',
        city: city,
        state: state,
    };
};
export var mapB2CPaymentAddressToFormModel = function (address, paymentValues) {
    var _a;
    return ({
        isDefault: !!(address === null || address === void 0 ? void 0 : address.isDefault),
        addressLine1: paymentValues.addressLine1,
        addressLine2: paymentValues.addressLine2,
        companyName: '',
        firstName: address.name.firstName,
        lastName: address.name.lastName,
        nickName: '',
        primaryPhone: address.primaryPhone.number,
        alternatePhone: (_a = address.alternatePhone) === null || _a === void 0 ? void 0 : _a.number,
        zipCode: paymentValues.zipCode,
        cityState: paymentValues.cityState,
    });
};
export var mapB2CPaymentAddressToRequestModel = function (address, paymentValues) {
    var addressValues = mapB2CPaymentAddressToFormModel(address, paymentValues);
    return mapEditAddressToRequestModel(false, addressValues, address);
};
